import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Status from "./type";

export const getMaintenanceStatusListSaga = createAction(
  "GET_MAINTENANCE_STATUS",
  ({ payload, params }: SagaActionParams<Status.MaintenanceStatusDto[]>) => ({
    payload,
    url: "/api/admin/maintenancestatuses" + (params ? params : ""),
  })
);
export const getMaintenanceStatusDetailsSaga = createAction(
  "GET_MAINTENANCESTATUS_DETAILS",
  ({ payload, id }: SagaActionParams<Status.MaintenanceStatusDetailDto>) => ({
    payload,
    url: "/api/admin/maintenancestatuses/" + id,
  })
);
export const createMaintenanceStatusSaga = createAction(
  "CREATE_MAINTENANCESTATUS",
  ({ payload, body }: SagaActionParams<Status.MaintenanceStatusDto>) => ({
    payload,
    url: "/api/admin/maintenancestatuses",
    body,
  })
);
export const updateMaintenanceStatusSaga = createAction(
  "UPDATE_MAINTENANCESTATUS",
  ({ payload, id, body }: SagaActionParams<Status.MaintenanceStatusDto>) => ({
    payload,
    url: "/api/admin/maintenancestatuses/" + id,
    body,
  })
);
export const deleteMaintenanceStatusSaga = createAction(
  "DELETE_MAINTENANCESTATUS",
  ({ payload, id }: SagaActionParams<Status.MaintenanceStatusDto>) => ({
    payload,
    url: "/api/admin/maintenancestatuses/" + id,
  })
);

const maintenanceStatusesSaga = [
  takeLatest<any>(
    getMaintenanceStatusListSaga.toString(),
    (payload: SagaGenericParams<Status.MaintenanceStatusDto[]>) =>
      getSaga<Status.MaintenanceStatusDto[]>(payload)
  ),
  takeLatest<any>(
    getMaintenanceStatusDetailsSaga.toString(),
    (payload: SagaGenericParams<Status.MaintenanceStatusDetailDto>) =>
      getSaga<Status.MaintenanceStatusDetailDto>(payload)
  ),
  takeLatest<any>(
    createMaintenanceStatusSaga.toString(),
    (payload: SagaGenericParams<Status.MaintenanceStatusDto>) =>
      postSaga<Status.MaintenanceStatusDto>(payload)
  ),
  takeLatest<any>(
    updateMaintenanceStatusSaga.toString(),
    (payload: SagaGenericParams<Status.MaintenanceStatusDto>) =>
      putSaga<Status.MaintenanceStatusDto>(payload)
  ),
  takeLatest<any>(
    deleteMaintenanceStatusSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Status.MaintenanceStatusDto>(payload)
  ),
];

export default maintenanceStatusesSaga;
